import { colors } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { typographyCss } from 'common/typography';

import SendOffer from './SendOffer';
import yuhoImage from './images/yuho-love.png';
import { OfferMonetaryAmount, getAvailableOfferForCurrency, isCompensationOfferAvailable } from './utils';

type CompensationOfferBannerProps = {
  venueId: string;
  currency: Currency;
  purchaseId: string;
  rating?: number;
  onSendOffer: () => void;
};

const Banner = styled.div`
  background: ${colors.wolt8};
  border-radius: 8px;
  overflow: hidden;
  display: flex;
`;

const Content = styled.div`
  padding: 16px;
  flex-grow: 1;
  align-self: center;
`;

const Text = styled.p`
  ${typographyCss.Body3};
  margin-block-start: 0;
  margin-block-end: 8px;
`;

const Image = styled.div`
  align-self: flex-end;
  margin-block-start: 16px;
  margin-inline-end: 16px;
  width: 56px;
  min-height: 79px;
  flex-shrink: 0;
  background: url(${yuhoImage}) no-repeat bottom;
`;

const CompensationOfferBanner = ({
  venueId,
  currency,
  purchaseId,
  rating,
  onSendOffer,
}: CompensationOfferBannerProps) => {
  const availableOffer = getAvailableOfferForCurrency(currency);

  if (rating === undefined || !isCompensationOfferAvailable(rating) || !availableOffer) {
    return null;
  }

  return (
    <Banner>
      <Content>
        <Text>
          <FormattedMessage
            id="insights.ratings-and-reviews.offers.banner-text"
            values={{
              amountAndUnit: <OfferMonetaryAmount {...availableOffer} />,
              days: availableOffer.validityInDays,
            }}
          />
        </Text>
        <SendOffer venueId={venueId} currency={currency} purchaseId={purchaseId} onSendOffer={onSendOffer} />
      </Content>
      <Image />
    </Banner>
  );
};

export default CompensationOfferBanner;
